import { ReactComponent as Minimize } from "./svg/icon-minimize.svg";

export const IconMinimize = () => <Minimize />;
